import { HttpHeaders } from '@angular/common/http';

export function getCustomHeaders(): () => HttpHeaders {
  return () =>
    new HttpHeaders({
      'x-api-key': '0d7f4b1b-0d7f-4b1b-9d0f-8b0f3f7c6f2a'
    });
}
